
import { Component, Vue } from "vue-property-decorator";
import LayoutMenuButton from "./layout-menu-button.vue";
import LayoutMenuMain from "./menu-main.vue";

import LayoutMenuHome from "./menu-home.vue";
import { ILayoutMenuProps } from "@interfaces/layout-menu-props";

@Component({
  components: {
    LayoutMenuButton,
    LayoutMenuHome,
    LayoutMenuMain
  }
})
export default class LayoutMenu extends Vue {
  get menus(): ILayoutMenuProps[] {
    const menus: ILayoutMenuProps[] = [
      {
        name: "home",
        componentName: "LayoutMenuHome"
      },
      {
        name: "home",
        componentName: "LayoutMenuMain"
      }
    ];

    return menus;
  }
}
